const initialState = {
    show: false,
    title: '',
    history: []
}

export enum DialogTypes {
    INTERROGATOR = 'INTERROGATOR',
}

export enum ActionButtons {
    DIRECT_DOWNLOAD = 'DIRECT_DOWNLOAD',
    ADD_TO_BASKET = 'ADD_TO_BASKET',
    SHOW_BASKET = 'SHOW_BASKET',
    DISMISS = 'DISMISS'
}

export const dialogReducer = (state = initialState, action: any) => {
    const data = {
        type: DialogTypes.INTERROGATOR,
        title: action.payload?.title || '',
        message: action.payload?.message || '',
        actionButtons: action.payload?.actionButtons || [],
        info: action.payload?.info || {},
        item: action.payload?.item || null
    }

    switch (action.type) {
        case 'SHOW_DIALOG':
            return {
                ...state,
                ...data,
                show: true,
                history: [...state.history, { [data.item.identifier]: data }]
            }
        case 'HIDE_DIALOG':
            return {
                ...state,
                show: false
            }
        case 'REPEAT_DIALOG':
            return {
                ...state,
                ...action.payload.data,
                show: true,
            }
        default:
            return state;
    }
}